/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from "@mui/system";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import TextField from "@mui/material/TextField";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MaterialSearchVM from "../viewmodel/MaterialSearchVM";
import CCarousel from "../../../../basecomp/components/CCarousel";
import CBackDrop from "../../../../basecomp/components/CBackDrop";
import CText from "../../../../basecomp/components/CText";
import CCustomCard from "../../../../basecomp/components/CCustomCard";
import PreviewIcon from "@mui/icons-material/Preview";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
} from "@mui/material";

const MaterialSearch = (props) => {
  const {
    setSpDetails,
    setSpData,
    setLightboxOpen,
    jobCardNumber,
    handleToastOpen,
    lclMaterialNo,
    setlclMaterialNo,
    spData,
  } = props;
  const {
    showTable,
    tableData,
    modalOpen,
    setModalOpen,
    handleChange,
    addToCart,
    handleButtonClick,
    material,
    setMaterial,
    globalMaterial,
    setGlobalMaterial,
    materialDesc,
    setMaterialDesc,
    manufName,
    setManufName,
    manufNo,
    setManufNo,
    equipFunc,
    setEquipFunc,
    binloc,
    setBinLoc,
    setSearchQuery,
    searchQuery,
    setOpenCarousel,
    openCarousel,
    isLoading,
    clearSelection,
    quantity,
    pgrData,
    levelOneData,
    levelTwoData,
    levelThreeData,
    levelFourData,
    handleCheckBtnClick,
    selectedItems,
    handleResetFilter,
    handleResetAllFilter,
    setPage,
    setRowsPerPage,
    page,
    rowsPerPage,
    handleAddImage,
    handleOpenModal,
    handleImageClick,
    sliderImages,
    getRowBackgroundColor,
    handleRowSelection,
    successfulItems,
    recordsQuantity,
    setRecordsQuantity
  } = MaterialSearchVM({
    setSpDetails,
    setLightboxOpen,
    jobCardNumber,
    setSpData,
    handleToastOpen,
    lclMaterialNo,
    setlclMaterialNo,
    spData,
  });

  const { t } = useTranslation();

  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(tableData);

    // const filtered = tableData.filter((data) =>
    //   Object.entries(data).some(([key, value]) => {
    //     const excludedKeys = ["id", "created_at", "image_links"];
    //     if (excludedKeys.includes(key)) return false;
    //     if (value === null || value === undefined) return false;
    //     const searchValue = searchQuery.toLowerCase();
    //     const stringValue = String(value).toLowerCase();
    //     return stringValue.includes(searchValue);
    //   })
    // );
    // setFilteredData(filtered)
    // setRecordsQuantity(filtered.length)

  }, [tableData]);


  return (
    <>
      <>
        <CBackDrop cOpen={isLoading} />
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            margin: {
              xs: 0,
              sm: 0,
              md: "1.5em 0.9em 0.5em 0.9em"
            }
          }}
        >
          <CText cVariant="header_card" cText={t('material_search')} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            margin: {
              xs: 0,
              sm: 0,
              md: "0 .9em"
            }
          }}
        >
          <Grid container spacing={1.5}>
            <CCustomCard
              title={t('pgr_id')}
              data={pgrData}
              filterType="pgr_id"
              handleCheckBtnClick={handleCheckBtnClick}
              selectedItems={selectedItems}
              onResetFilter={handleResetFilter}
            />
            <CCustomCard
              title={t('level1_id')}
              data={levelOneData}
              filterType="level1_id"
              handleCheckBtnClick={handleCheckBtnClick}
              selectedItems={selectedItems}
              onResetFilter={handleResetFilter}
            />
            <CCustomCard
              title={t('level2_id')}
              data={levelTwoData}
              filterType="level2_id"
              handleCheckBtnClick={handleCheckBtnClick}
              selectedItems={selectedItems}
              onResetFilter={handleResetFilter}
            />
            <CCustomCard
              title={t('level3_id')}
              data={levelThreeData}
              filterType="level3_id"
              handleCheckBtnClick={handleCheckBtnClick}
              selectedItems={selectedItems}
              onResetFilter={handleResetFilter}
            />
            <CCustomCard
              title={t('level4_id')}
              data={levelFourData}
              filterType="level4_id"
              handleCheckBtnClick={handleCheckBtnClick}
              selectedItems={selectedItems}
              onResetFilter={handleResetFilter}
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          sx={{
            margin: {
              xs: 0,
              sm: 0,
              md: "0 .9rem"
            }
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <div style={{ marginTop: 4 }}>
                <Typography noWrap>{t('local_material_number')}</Typography>
                <TextField
                  size="small"
                  id="job_directive"
                  style={{ marginTop: "0.55em", width: "100%" }}
                  label={t('enter_value')}
                  value={lclMaterialNo !== "" ? lclMaterialNo : material}
                  onChange={(e) => {
                    if (lclMaterialNo !== "") {
                      setlclMaterialNo(e.target.value);
                    } else {
                      setMaterial(e.target.value);
                    }
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div style={{ marginTop: 4 }}>
                <Typography noWrap>{t('global_material_number')}</Typography>
                <TextField
                  size="small"
                  id="job_directive"
                  style={{ marginTop: "0.55em", width: "100%" }}
                  label={t('enter_value')}
                  value={globalMaterial}
                  onChange={(e) => setGlobalMaterial(e.target.value)}
                />
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                marginTop: {
                  xs: 0,
                  sm: 0,
                  md: 0.4
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" noWrap>
                  {t('material_description')}
                </Typography>
                <ThemeProvider>
                  <Tooltip
                    title={t('material_description_tooltip')}
                    placement="bottom"
                  >
                    <span style={{ marginLeft: 5 }}>
                      <InfoIcon
                        style={{
                          color: "#052660",
                          marginTop: 2,
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>
                </ThemeProvider>
              </div>
              <TextField
                label={t('enter_value')}
                size="small"
                style={{ marginTop: "0.5em", width: "100%" }}
                value={materialDesc}
                onChange={(e) => setMaterialDesc(e.target.value)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                marginTop: {
                  xs: 0,
                  sm: 0,
                  md: 0.4
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" noWrap>
                  {t('manufacture_name')}
                </Typography>
                <ThemeProvider>
                  <Tooltip
                    title={t('manufacture_name_tooltip')}
                    placement="bottom"
                  >
                    <span style={{ marginLeft: 5 }}>
                      <InfoIcon
                        style={{
                          color: "#052660",
                          marginTop: 2,
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>
                </ThemeProvider>
              </div>
              <TextField
                size="small"
                id="job_directive"
                style={{ marginTop: "0.5em", width: "100%" }}
                label={t('enter_value')}
                value={manufName}
                onChange={(e) => setManufName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <div style={{ marginTop: 4 }}>
                <Typography noWrap> {t('manufacture_part_number')}</Typography>
                <TextField
                  size="small"
                  id="job_directive"
                  style={{ marginTop: "0.55em", width: "100%" }}
                  label={t('enter_value')}
                  value={manufNo}
                  onChange={(e) => setManufNo(e.target.value)}
                />
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                marginTop: {
                  xs: 0,
                  sm: 0,
                  md: 0.4
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" noWrap>
                  {t('equipment_function')}
                </Typography>
                <ThemeProvider>
                  <Tooltip
                    title={t('equipment_function_tooltip')}
                    placement="bottom"
                  >
                    <span style={{ marginLeft: 5 }}>
                      <InfoIcon
                        style={{
                          color: "#052660",
                          marginTop: 2,
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>
                </ThemeProvider>
              </div>
              <TextField
                size="small"
                id="job_directive"
                style={{ marginTop: "0.5em", width: "100%" }}
                label={t('enter_value')}
                value={equipFunc}
                onChange={(e) => setEquipFunc(e.target.value)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={3}
              sx={{
                marginTop: {
                  xs: 0,
                  sm: 0,
                  md: 0.4
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body1" noWrap>
                  {t('bin_location')}
                </Typography>
                <ThemeProvider>
                  <Tooltip
                    title={t('bin_location_tooltip')}
                    placement="bottom"
                  >
                    <span style={{ marginLeft: 5 }}>
                      <InfoIcon
                        style={{
                          color: "#052660",
                          marginTop: 2,
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  </Tooltip>
                </ThemeProvider>
              </div>
              <TextField
                size="small"
                id="job_directive"
                style={{ marginTop: "0.5em", width: "100%" }}
                label={t('enter_value')}
                value={binloc}
                onChange={(e) => setBinLoc(e.target.value)}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={11.9}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "1.5em",
              gap: "10px",
            }}
          >
            <Tooltip title={t('search')}>
              <IconButton
                id="d-cat-search"
                style={{
                  backgroundColor: "#052660",
                  color: "#FFFFFF",
                  borderRadius: 5,
                  padding: "10px",
                }}
                onClick={handleButtonClick}
              >
                <SearchIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('reset')}>
              <IconButton
                id="d-cat-reset"
                style={{
                  backgroundColor: "#052660",
                  color: "#FFFFFF",
                  borderRadius: 5,
                  padding: "10px",
                }}
                onClick={handleResetAllFilter}
              >
                <AutorenewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>

        {showTable && (
          <>
            <Grid container sx={{ marginTop: "0.05rem" }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                sx={{
                  margin: {
                    xs: 0,
                    sm: 0,
                    md: "0.5em .9em"
                  }
                }}
              >
                <CText cVariant="header_card" cText={t('search_details')} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                sx={{
                  textAlign: "right",
                  paddingRight: "0.5em",
                  margin: {
                    xs: "0 0 1em 0",
                    sm: "0 0 1em 0",
                    md: "0 .4em 1.5em 0em"
                  },
                }}
              >
                <TextField
                  variant="outlined"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder={t('search')}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                    endAdornment: searchQuery && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setSearchQuery("")}
                          edge="end"
                          size="small"
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: {
                      height: "40px",
                      width: "100%", // This will respect the container width
                      maxWidth: "310px", // Keep your desired max width
                    },
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "4px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                  }}
                />
              </Grid>

              {showTable && tableData.length > 0 && (
                <Grid item xs={12} sm={12} md={12}>
                  <Box sx={{
                    overflowX: "auto",
                    margin: { xs: 0, sm: 0, md: "0 .9em" }
                  }}
                  >
                    <Table>
                      <TableHead
                        sx={{
                          backgroundColor: "#052660",
                          fontWeight: "semibold",
                          color: "white",
                          fontSize: 16,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          "& .MuiTableRow-root": {
                            height: "48px", // Custom header row height
                          },
                          "& .MuiTableCell-root": {
                            padding: "0 16px", // Minimal padding for header cells
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell>
                            <IconButton sx={{ color: "white" }}>
                              <ShoppingCartOutlinedIcon
                                sx={{ fontSize: "22px" }}
                              />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <IconButton sx={{ color: "white" }}>
                              <CameraAltIcon sx={{ fontSize: "21px" }} />
                            </IconButton>
                          </TableCell>
                          <TableCell sx={{ color: "white" }}>
                            {t('material')}
                          </TableCell>
                          <TableCell
                            style={{ width: "150px" }}
                            sx={{ color: "white" }}
                          >
                            {t('description')}
                          </TableCell>
                          <TableCell
                            style={{ width: "150px" }}
                            sx={{ color: "white" }}
                          >
                            {t('local_material_description')}
                          </TableCell>
                          <TableCell sx={{ color: "white" }}>  {t('gmn')}</TableCell>
                          <TableCell
                            style={{ width: "150px" }}
                            sx={{ color: "white" }}
                          >
                            {t('gbl_material_desc')}
                          </TableCell>
                          <TableCell sx={{ color: "white" }}>
                            {t('equipment_function')}
                          </TableCell>
                          <TableCell sx={{ color: "white" }}>
                            {t('bin_location')}
                          </TableCell>
                          <TableCell sx={{ color: "white" }}>  {t('ohq')}</TableCell>
                          <TableCell sx={{ color: "white" }}>  {t('uom')}</TableCell>
                          <TableCell sx={{ color: "white" }}>
                            {t('manufacturer_info')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        sx={{
                          "& .MuiTableRow-root": {
                            height: "40px",
                          },
                          "& .MuiTableCell-root": {
                            padding: "0 16px",
                          },
                        }}
                      >
                        {showTable && filteredData.length > 0 ? (
                          filteredData
                            .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                            .map((data) => {
                              const isSuccessful = successfulItems.includes(
                                data.id
                              );
                              return (
                                <TableRow
                                  key={data.id}
                                  style={{
                                    backgroundColor:
                                      getRowBackgroundColor(data),
                                  }}
                                  onClick={() => handleRowSelection(data.id)}
                                >
                                  <TableCell>
                                    {isSuccessful ? (
                                      <IconButton color="success">
                                        <CheckIcon
                                          sx={{
                                            fontSize: "22px",
                                            color: "#052660",
                                          }}
                                        />
                                      </IconButton>
                                    ) : (
                                      <Tooltip title={t('add_to_cart')}>
                                        <IconButton
                                          color="#052660"
                                          onClick={() =>
                                            handleOpenModal(data.id)
                                          }
                                        >
                                          <ShoppingCartOutlinedIcon
                                            sx={{
                                              fontSize: "22px",
                                              color: "#052660",
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {data.image_links.length === 0 ||
                                      data.image_links === undefined ? (
                                      <Tooltip title={t('upload_image')}>
                                        <IconButton
                                          id="add_image"
                                          onClick={() =>
                                            handleAddImage(data.material_no)
                                          }
                                        >
                                          <AddAPhotoIcon
                                            sx={{
                                              fontSize: "22px",
                                              color: "#052660",
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip title={t('view_image')}>
                                        <IconButton
                                          id="display_image"
                                          onClick={() =>
                                            handleImageClick(data.image_links)
                                          }
                                        >
                                          <PreviewIcon
                                            sx={{
                                              fontSize: "24px",
                                              color: "#052660",
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.material_no}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "150px" }}
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.material_desc}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "150px" }}
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.local_material_desc}
                                  </TableCell>
                                  <TableCell>
                                    {data.industry_std_desc}
                                  </TableCell>
                                  <TableCell
                                    style={{ width: "150px" }}
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.long_desc}
                                  </TableCell>
                                  <TableCell>{data.equipment_func}</TableCell>
                                  <TableCell>{data.bin_location}</TableCell>
                                  <TableCell>{data.ohqty}</TableCell>
                                  <TableCell>{data.b_un}</TableCell>
                                  <TableCell>
                                    {(data.mpn_name1 ||
                                      data.manufac_item_code) && (
                                        <div
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {data.mpn_name1 &&
                                            data.manufac_item_code ? (
                                            <div>
                                              {data.mpn_name1} -{" "}
                                              {data.manufac_item_code}
                                            </div>
                                          ) : (
                                            data.mpn_name1 ||
                                            data.manufac_item_code
                                          )}
                                        </div>
                                      )}

                                    {(data.mpn_name2 || data.mpn_number1) && (
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {data.mpn_name2 && data.mpn_number1 ? (
                                          <div>
                                            {data.mpn_name2} -{" "}
                                            {data.mpn_number1}
                                          </div>
                                        ) : (
                                          data.mpn_name2 || data.mpn_number1
                                        )}
                                      </div>
                                    )}

                                    {(data.mpn_name3 || data.mpn_number2) && (
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {data.mpn_name3 && data.mpn_number2 ? (
                                          <div>
                                            {data.mpn_name3} -{" "}
                                            {data.mpn_number2}
                                          </div>
                                        ) : (
                                          data.mpn_name3 || data.mpn_number2
                                        )}
                                      </div>
                                    )}

                                    {(data.mpn_name4 || data.mpn_number3) && (
                                      <div
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {data.mpn_name4 && data.mpn_number3 ? (
                                          <div>
                                            {data.mpn_name4} -{" "}
                                            {data.mpn_number3}
                                          </div>
                                        ) : (
                                          data.mpn_name4 || data.mpn_number3
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        ) : (
                          <TableRow>
                            <TableCell colSpan={10} align="center">
                              {t('no_data')}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Box>
                  {showTable && filteredData.length > 0 ? (<div
                    style={{
                      position: "sticky",
                      bottom: 0,
                      backgroundColor: "white",
                      borderTop: "1px solid rgba(224, 224, 224, 1)",
                    }}
                  >
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      component="div"
                      count={recordsQuantity}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={(event, newPage) => setPage(newPage)}
                      onRowsPerPageChange={(event) => {
                        const newRowsPerPage = parseInt(event.target.value, 10);
                        setRowsPerPage(newRowsPerPage);
                        setPage(0);
                      }}
                      labelRowsPerPage={t('Rows')}
                    />
                  </div>) : ""}
                </Grid>
              )}
            </Grid>
          </>
        )}

        {openCarousel && (
          <CCarousel
            cOpen={openCarousel}
            images={sliderImages}
            cClose={() => setOpenCarousel(false)}
          />
        )}
        <Dialog
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          PaperProps={{
            style: {
              marginBottom: "25em",
              maxWidth: "23em",
              width: "100%",
            },
          }}
        >
          <AppBar
            position="static"
            style={{
              backgroundColor: "#63b144",
              alignItems: "center",
            }}
          >
            <Toolbar>
              <ShoppingCartOutlinedIcon />
            </Toolbar>
          </AppBar>

          <DialogContent>
            <div className="modal-body">
              <Typography
                style={{
                  color: "#1976d2",
                  marginBottom: "1em",
                }}
              >
                {t('qty')}
              </Typography>
              <TextField
                id="standard-basic"
                fullWidth
                value={quantity}
                onChange={handleChange}
                variant="standard"
              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button style={{ color: "#1976d2" }} onClick={addToCart}>
              {t('ok')}
            </Button>
            <Button onClick={clearSelection} style={{ color: "#1976d2" }}>
              {t('cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </>
  );
};

export default MaterialSearch;
